export default __webpack_public_path__ + "static/media/parenthood-frame.aa15d3f1.png";